<template>
  <v-dialog
      content-class="image-gallery"
      v-model="visible"
      fullscreen
      dark
  >
    <v-card>
      <v-toolbar dark flat class="justify-end">
        <v-toolbar-title v-if="title" class="title font-weight-light">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn class="mr-1" icon dark @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <swiper class="align-center" :options="swiperOptions" ref="swiper">
        <swiper-slide v-for="(item, index) in items" :key="index" class="d-flex justify-center">
          <v-img max-height="calc(100vh - 160px)" max-width="70vw" class="ma-12" contain :src="item.src" :alt="item.alt"></v-img>
          <div v-if="item.description" class="description text-center subtitle-1 font-weight-light">{{ item.description }}</div>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
      </swiper>
    </v-card>
  </v-dialog>
</template>

<script>
  import { get, sync } from 'vuex-pathify';

  export default {
    name: "ImgGallery",
    data() {
      return {
        swiperOptions: {
          centeredSlides: true,
          slidesPerView: 1,
          spaceBetween: 30,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    computed: {
      ...get('imgGallery', ['items', 'title']),
      ...sync('imgGallery', ['activeIndex', 'visible'])
    },
    methods: {
      setActive (value) {
        this.$refs.swiper.swiper.activeIndex = value;
        this.$refs.swiper.swiper.update();
      }
    },
    watch: {
      visible (val) {
        if (val) {
          var self = this;
            this.$nextTick(() => {
              self.setActive(self.activeIndex);
            });
        }
      }
    },
  }
</script>

<style>
  .v-dialog.image-gallery .v-card {
    border-radius: 0;
  }
  .v-dialog.image-gallery div.v-toolbar__content {
    padding-right: 4px!important;
  }
  .v-dialog.image-gallery .swiper-container {
    height: calc(100vh - 68px);
  }
  .v-dialog.image-gallery .swiper-slide .description {
    position: absolute;
    /*top: 4px;*/
  }

  @media (min-width: 600px) {
    .v-dialog.image-gallery .swiper-container {
      margin: 0 20px;
    }
  }
</style>